import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import CustomerService from "services/Setup/Organization/customerService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  CustomerList: {},
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const getCustomerList = createAsyncThunk(
  "customer/getCustomerList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await CustomerService.getCustomerList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const CustomerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder

      //list personal customer
      .addCase(getCustomerList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCustomerList.fulfilled, (state, action) => {
        state.loading = false;
        state.CustomerList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getCustomerList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  CustomerSlice.actions;

export default CustomerSlice.reducer;
